export default function Laptop() {
    return (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_608_33135)">
                <path
                    d="M26.6984 6.99561H7.30181C6.4561 6.99561 5.77051 7.68119 5.77051 8.52691V22.3087H28.2297V8.52691C28.2297 7.68119 27.5441 6.99561 26.6984 6.99561Z"
                    stroke="black"
                    strokeWidth="1.53131"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.0094 27.4131H5.99031C4.90696 27.4131 4.16618 26.3189 4.56852 25.3131L5.77026 22.3087H28.2294L29.4312 25.3131C29.8335 26.3189 29.0927 27.4131 28.0094 27.4131Z"
                    stroke="black"
                    strokeWidth="1.53131"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.9795 9.0376H18.0212" stroke="black" strokeWidth="1.53131" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_608_33135">
                    <rect width="32.6679" height="32.6679" fill="white" transform="translate(0.666016 0.870605)" />
                </clipPath>
            </defs>
        </svg>
    );
}
